var map = {
	"./case-studies-grid/block": [
		"./blocks/case-studies-grid/block.tsx",
		9,
		565
	],
	"./case-studies-stage/block": [
		"./blocks/case-studies-stage/block.tsx",
		9,
		874
	],
	"./example-block/block": [
		"./blocks/example-block/block.blade.php",
		7,
		981
	],
	"./hero/block": [
		"./blocks/hero/block.blade.php",
		7,
		765
	],
	"./leistungen/block": [
		"./blocks/leistungen/block.tsx",
		9,
		719
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./blocks lazy recursive ^\\.\\/.*\\/block$";
module.exports = webpackAsyncContext;